import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { findIndex } from 'lodash';
import { LIST_ITEMS_SIZE } from 'config';
import getLocalized from 'utils/get-localized';
import ListItem from 'components/ListItem';
import { StyledEpisodesTitle, StyledEpisodeslList } from '../StyledComponents';

const listConfig = {
  enterTo: 'last-focused',
  leaveFor: {
    up: '@PLAYER_CONTROLS',
    right: '',
    bottom: '',
  },
  debounce: {
    time: 150,
    options: {
      leading: true,
      trailing: false,
      maxWait: 200,
    },
  },
};

const Episodes = ({ season, onEnter, onFocus, focusedEpisodeId }) => {
  const { title } = getLocalized(season.titles, season.title);
  const listId = `episodes-list-${season.id}`;
  const defaultElementIndex = findIndex(season.episodes.content, { id: focusedEpisodeId });

  return (
    <div>
      <StyledEpisodesTitle>{title}</StyledEpisodesTitle>
      <StyledEpisodeslList
        listId={listId}
        sectionName={'EPISODES'}
        itemSize={LIST_ITEMS_SIZE.LARGE.width}
        startScrollIndex={1}
        items={season.episodes.content}
        onEnter={onEnter}
        onFocus={onFocus}
        defaultIndex={defaultElementIndex}
        config={{ ...listConfig, defaultElement: `.${listId}-item-${defaultElementIndex}` }}
        itemRender={(props) => (
          // Bridge for old non-clean code
          <ListItem
            key={props.key}
            className={`${listId}-item-${props.index}`}
            onFocus={() => props.onFocus(props.index)}
            onEnter={() => props.onEnter(props.index)}
            isActive={props.index === defaultElementIndex}
            itemIndex={props.index}
            item={{ ...props.item, type: 'EPISODE' }}
            itemSize={LIST_ITEMS_SIZE.LARGE}
          />
        )}
      />
    </div>
  );
};

Episodes.propTypes = {
  season: PropTypes.shape({
    episodes: PropTypes.shape({ content: PropTypes.array.isRequired }).isRequired,
    id: PropTypes.number.isRequired,
    title: PropTypes.object,
    titles: PropTypes.object,
  }).isRequired,
  onEnter: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  focusedEpisodeId: PropTypes.number,
};

export default memo(Episodes);
